import { Component, Input, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-profile-website-admin-config',
  templateUrl: './profile-website-admin-config.component.html',
  styleUrls: ['./profile-website-admin-config.component.scss']
})
export class AtwProfileWebsiteAdminConfig extends AtwUpdateDbComponent  implements OnInit {
@Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_khi_chon',
      index: 1,
    },
    {
      title: 'hieu_ung_khi_cham',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien',
      index: 3,
    }
  ];
  fonts = [];
  backgroundColor: any = [];
  menuList: any = [
    {
      name: 'thong_tin',
      key: 'user_info'
    },
    {
      name: 'doi_mat_khau',
      key: 'user_password'
    },
    {
      name: 'don_mua',
      key: 'user_purchase'
    },
    {
      name: 'dang_xuat',
      key: 'user_signout'
    },
  ];
  configMode: 'basic' | 'advanced' = 'basic';


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
        public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  ngOnInit() {
    forkJoin([
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([background_colors, fonts]: any) => {
      this.fonts = fonts;
      this.backgroundColor = background_colors;
    });

    this.updateObject();
  }


  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /**
   * Hàm này dùng để click chọn màu nền của danh sách màu. 
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event, type, mobileid?: number | null) {
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    // Lấy ra element màu được click từ tham số event trả về.
    var activeGradient = document.querySelector('.container-color .active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');

    const data = this.device == 'desktop' ? this.class[`${type}__item`] : this.class[`${type}__list--item${mobileid}`]
    // Lấy giá trị màu được click từ tham số bgColor.
    //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
    // 
    data['background-color'] = `rgba(${this.hexToRGB(bgColor.bgColor)}, ${(this.device == 'desktop') ? this.config[`${type}_background-color`].value_range : this.config[`background-color`].value_range})`;
    this.updateObject()
  }



  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update class vào database.
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update config vào database.
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  // }


  // /**
  //  * Cập nhật staticdata vào database.
  //  */
  // updateStaticData() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then((bool) => {
  //     });
  // }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false
  };
}
